import React, { useEffect, useState } from 'react';
import * as MinistryReportApi from '../../api/MinistryReportApi';
import { toast } from 'react-toastify';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import IncidentListingModal from './IncidentListingModal';
import moment from 'moment';

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const categoryColors = {
  drivedownload: 'rgb(254, 195, 190)',
  contentdelivery: 'rgb(224,224,224)',
  contentprocess: 'rgb(255,224,143)',
  entryofcandidates: 'rgb(203,235,174)',
  registration: 'rgb(179,218,244)',
  aadharauthentication: 'rgb(187,211,218)',
  examcommencement: 'rgb(223,194,238)',
  allowedcandidateslogin: 'rgb(121,159,229)',
  examcompletion: 'rgb(144,132,219)',
  lockunlockincidents: 'rgb(122,234,203)',
};

const MinistryStackedChart = ({ data, selectedDatee, selectedShift }) => {
  const categories = Array.from(
    new Set(data.flatMap((entry) => Object.keys(entry.incidents)))
  );

  const dates = data.map((entry) => moment(entry.date).format('DD/MM/YYYY'));
  const datasets = categories.map((category) => {
    return {
      label: category,
      data: data.map((entry) => entry.incidents[category] || 0),
      backgroundColor:
        categoryColors[category.toLowerCase().replace(/[^a-z0-9]/g, '')] ||
        'rgb(100, 100, 100)', // Default fallback color
    };
  });

  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );

  const [modalData, setModalData] = useState([]);

  const [filter, setFilter] = useState({
    category: '',
    date: '',
    shift: '',
  });

  const fetchModalData = async () => {
    const response = await MinistryReportApi.getDateAndCategoryWiseIncidents(
      filter
    );

    if (response?.success) {
      setModalData(response?.data);
    } else {
      toast.error(`Error fetching stage incidents:  ${response?.message}`);
    }
  };

  useEffect(() => {
    if (filter.category) {
      fetchModalData();
    }
  }, [filter.category, filter.date]);

  const chartData = {
    labels: dates,
    datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: { boxWidth: 12 },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { maxRotation: 45, minRotation: 45 },
        barPercentage: 1.0,
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Incident Count',
        },
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const { datasetIndex, index } = elements[0];
        const clickedCategory = chartData.datasets[datasetIndex].label;
        const clickedDate = data[index].date;

        setFilter((prev) => ({
          ...prev,
          category: clickedCategory,
          date: clickedDate,
        }));
        setShowIncidentDetailsModal((prev) => ({ ...prev, show: true }));
      }
    },
  };

  return (
    <div>
      <div style={{ height: '500px', width: '100%' }}>
        <Bar data={chartData} options={options} />
      </div>
      {showIncidentDetailsModal.show && (
        <IncidentListingModal
          showIncidentDetailsModal={showIncidentDetailsModal}
          setShowIncidentDetailsModal={setShowIncidentDetailsModal}
          incidents={modalData}
          selectedItemName={`${moment(filter?.date).format('DD/MM/YYYY')} ${
            filter?.category
          }`}
        />
      )}
    </div>
  );
};

export default MinistryStackedChart;
